import mobileMenu from "./modules/MobileMenu";
import GoogleMapsAPI from "../gutenberg/blocks/location-finder/modules/GoogleMapsAPI";
// import FormControl from "./modules/FormControl";

const topBarHeight = 133;

/* -------------------------------------------------------------------------- */
/*                              Init Mobile Menu                              */
/* -------------------------------------------------------------------------- */
mobileMenu({
  selector: ".mobile-menu",
  block: "mobile-menu",
  toggleActiveClass: "header__hamburger--open",
});

/* -------------------------------------------------------------------------- */
/*                                Form Control                                */
/* -------------------------------------------------------------------------- */
// const formControlContainers = document.querySelectorAll(".qualsight-form-control");

// formControlContainers.forEach((container) => {
//   console.log(container);
//   // console.log("another");
//   const f = new FormControl(container);
// });

/* -------------------------------------------------------------------------- */
/*                         Init Header Scroll Listener                        */
/* -------------------------------------------------------------------------- */
// const header = document.querySelector(".header--follow");

// // const scrollOffset = WP_VARS.isAdmin === "1" ? 41 + 32 : 41;
// // console.log(scrollOffset);
// const scrollOffset = 41;

// window.addEventListener("scroll", () => {
//   // window scroll listener
//   if (
//     window.scrollY >= scrollOffset ||
//     (window.innerWidth < topBarBreakpoint && Boolean(window.scrollY))
//   ) {
//     // top bar is 41px
//     header.classList.add("header--scrolling");
//   } else {
//     header.classList.remove("header--scrolling");
//   }
// });

/* -------------------------------------------------------------------------- */
/*                         Init Follower CTA Listener                         */
/* -------------------------------------------------------------------------- */
const followingCTA = document.querySelector(".following-cta");

if (followingCTA) {
  window.addEventListener("scroll", () => {
    // window scroll listener
    if (window.scrollY >= topBarHeight) {
      followingCTA.classList.add("following-cta--show");
    } else {
      followingCTA.classList.remove("following-cta--show");
    }
  });
}

/* -------------------------------------------------------------------------- */
/*                          Auto Populate Form Fields                         */
/* -------------------------------------------------------------------------- */
(async () => {
  const zipInput = document.querySelector("#input_1_6");
  const stateInput = document.querySelector("#input_1_5");
  const storedLocation = localStorage.getItem("location");

  if (storedLocation && (zipInput || stateInput)) {
    const { latitude: lat, longitude: lng } = JSON.parse(storedLocation);
    // geocode location
    const { apiKey } = window.MAP;

    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?key=${apiKey}&latlng=${lat},${lng}&result_type=postal_code`
    );

    if (res.status === "ZERO_RESULTS") return;

    let data = await res.json();

    if (zipInput) {
      zipInput.value = data.results[0].address_components[0].long_name;
    }

    if (stateInput) {
      stateInput.value = data.results[0].address_components[3].long_name;
    }
  }
})();
